<div id='screen'></div>
<div id='dlg'>
  <form #userForm='ngForm'  id="userForm">
    <div id='caption'>
      <h2><span [innerText]="selectDlgMode===0?'Property Verification':'Send Notification Packages'"></span>
        <div role='button' (click)='onCancel()'>
          <span class='cvt-icon-closeDelete'></span>
        </div>
      </h2>
    </div>
    <div id='content' *ngIf="auditType!='reverseAudit'">
      <div *ngIf="selectDlgMode===0" id='col1'>
        <div>Modifying the selected property will have the following effects.</div>
        <div id='packageNote'>
          <div>Modified Email Packages: <span [innerText]='totalPackages' ></span> </div>
          <div class='indent'>Passed Email Packages: <span [innerText]='passPackages' ></span></div>
          <div class='indent'>Failed Email Packages: <span [innerText]='failPackages' ></span></div>
        </div>
        <div>The effected email packages are shown to the right. Changes will only be applied to 'Checked' email packages.</div>
      </div>
      <div id='col2'>
        <div id='selectButtons' *ngIf="selectDlgMode===0" >
          <button class='slds-button cvt-secondary' (click)='onSelectAll()'>Select All</button>
          <button class='slds-button cvt-secondary' (click)='onSelectNone()'>Select None</button>
        </div>
        <div>
          <div id='selectIt' [class]="selectDlgMode===1?'selectItBigger':''" >
            <div *ngFor='let item of displayItems '>
              <ngl-checkbox *ngIf="selectDlgMode===0"  [label]="item.display">
                <input ngl type="checkbox" name="asdf" [(ngModel)]="item.selected" (change)="updateCounts()" />
              </ngl-checkbox>
              <div *ngIf="selectDlgMode===1"  [innerText]="item.display" ></div>
            </div>
          </div>
        </div>
        <div id='progressArea' *ngIf="showProgress" >
          <div></div>
          <div>Notifications: <span [innerText]="progressInfo.total"></span></div>
          <div>Completed: <span [innerText]="percentComplete"></span>%</div>
          <div>Recipient: <span [innerText]="progressInfo.message"></span></div>
        </div>
      </div>
    </div>
    <div id='content' *ngIf="auditType=='reverseAudit'">
      <div id='col1'>
        <div>{{emailMessage}}</div>
        <div id='selectIt' class="textPanel">
          <div *ngFor='let item of displayItems '>
          <div class='indent'><span [innerText]='item.display' ></span></div>
        </div>
        </div>
      </div>
    </div>
    <div id='buttons'>
      <div  *ngIf="auditType!='reverseAudit'">
        <button type="button" class='slds-button cvt-primary' (click)='onApplyChangesOrSendPackages()' [disabled]="isEmpty( displayItems) || disableButtons"
          [innerText]="selectDlgMode===0?'Apply Changes':'Send Packages'"></button>
        <button class='slds-button cvt-secondary' (click)='onCancel()'[disabled]="disableButtons" >Cancel</button>
      </div>
      <div  *ngIf="auditType=='reverseAudit'">
        <button type="button" class='slds-button cvt-primary' (click)='onApplyChangesOrSendPackages()'  [disabled]="isEmpty( displayItems)"
          [innerText]="selectDlgMode===0?'Apply Changes':'Send Packages'"></button>
        <button class='slds-button cvt-secondary' (click)='onCancel()' >Cancel</button>
      </div>
    </div>

  </form>
</div>
